<template>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('HomePage') }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="nav2?{ path: '/' }:''">{{nav1}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="nav2">{{nav2}}</el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
    import {getMyMenuObj} from '../../../utils/util'
    export default {
        name: "nav_tabar",
        data(){
            return{
                menu:[],
                nav1:'',
                nav2:'',
            }
        },
        mounted(){
            this.menu = JSON.parse(localStorage.getItem("menuData"))
            let path = ''
             
            if(this.$route.path=="/pbreport"){
                path = location.href.substring(location.href.indexOf("?"))
            }
            this.menu.map((item,index)=>{
                if(item.children){
                    item.children.map((i,d)=>{
                        if(i.url==(this.$route.path+path)){
                            this.nav2 = this.$t(getMyMenuObj().name) 
                            this.nav1= this.$t(item.name)
                        }
                    })
                }else if(item.url==this.$route.path){
                    this.nav1= this.$t(item.name)
                }
            })   
        },
        methods:{

        }
    }
</script>

<style scoped>

</style>
